import React from "react";
import { createContext, useState, useContext } from "react";

const AlteradoContext = createContext();

export const AlteradoProvider = ({children}) => {
    const [mostrarDado, setMostrarDado] = useState(false);
      const [respostaCerta, setResposta] = useState(null);
        const [respondido, setRespondido] = useState(false);
          const [botaoClicado, setBotaoClicado] = useState(null);
            const [mensagemnova, setMensagemnova] = useState('');
          
        
      
    
   
/*     console.log("Dado Context",mostrarDado)
 */
    return(
        <AlteradoContext.Provider value={{ mostrarDado, setMostrarDado, respostaCerta, setResposta, respondido, setRespondido, botaoClicado, setBotaoClicado, mensagemnova, setMensagemnova}}>
            {children}
            
        
        </AlteradoContext.Provider>
        ); 

        
};


 
export const useAlteradoContext = () => useContext(AlteradoContext);